module.exports = __webpack_public_path__ + "img/block2_poligrafia1.0ad5de1f.jpg";